<template>
  <DxDataGrid :ref="documenteDataGrid" :allowColumnReordering='true'
    :data-source='dsDocumente' :allowColumnResizing='true' :columnAutoWidth='false' :column-min-width='10'
    :columnResizingMode="'nextColumn'" :show-borders='true' :syncLookupFilterValues='false' :filter-sync-enabled='true'
    @row-dbl-click="onRowDblClick">
    <DxExport :enabled='true' :formats='["pdf", "xlsx"]'
      :load-panel="{ enabled: true, showIndicator: true, text: 'Loading...' }" />
    <DxFilterRow :visible='true' />
    <DxGrouping :context-menu-enabled='true'>
      <DxTexts group-continued-message='Continuat de pe pagina anterioara'
        group-continues-message='Continuat pe pagina urmatoare' />
    </DxGrouping>
    <DxGroupPanel :visible='true' emptyPanelText='Trage aici o coloana pentru a grupa datele' />
    <DxLoadPanel :enabled='true' text="Loading..." :indicator-src="'reload6.gif'" />
    <DxSorting mode='multiple' />
    <DxStateStoring :enabled='true' :filterValue='false' storage-key='dsDocumente' />
    <DxColumnChooser :enabled='true' title='Selector coloane' :allowSearch="true" sortOrder="asc"></DxColumnChooser>
    <DxSearchPanel :visible='true' :width='240' placeholder='Cauta ...'></DxSearchPanel>
    <DxPaging :page-size='10' :page-index='0' />
    <DxToolbar>
      <DxItem location="before" template="filterToggleTemplate" />
      <DxItem location="before" template="periodToggleTemplate" />
      <DxItem location="before" template="documentToggleTemplate" />
      <DxItem widget="dxButton" location="after" :options="addButtonOptions" />
      <DxItem name="searchPanel" />
      <DxItem name="exportButton" />
      <DxItem name="columnChooserButton" />
    </DxToolbar>

    <DxColumn data-field="Numar" cell-template="numarLinkTemplate"/>
    <DxColumn data-field="Categorie" />
    <DxColumn data-field="Tip" />
    <DxColumn data-field="Data" caption="Data Contabila" data-type="date" format="yyyy-MM-dd" />
    <DxColumn data-field="Document" caption="Document asociat" :visible="false" />
    <DxColumn data-field="Zona" caption="Zona" :visible="false" />
    <DxColumn data-field="AgentNume" caption="Nume Agent" :allowHiding="false" :showInColumnChooser="false"/>
    <DxColumn data-field="Curs" caption="Custom Curs Valutar" :visible="false" data-type="number" :allowSearch="false"/>
    <DxColumn data-field="LotFabricatie" caption="Lot Fabricatie" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="TvaLaIncasare" caption="TVA La Incasare?" :visible="false" cellTemplate="circleTemplate" :allowSearch="false"/>
    <DxColumn data-field="Explicatie" caption="Explicatie" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="DiverseExplicatii" caption="Diverse Explicatii" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="Observatii" caption="Observatii" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="ContractNumar" caption="Numar Contract" :visible="false" />
    <DxColumn data-field="LocDepozitare" caption="Loc de Depozitare" :visible="false" :allowSearch="false"/>
    <DxColumn data-field="Autofacturat" caption="Autofacturat?" :visible="false" cellTemplate="circleTemplate" :allowSearch="false"/>
    <DxColumn data-field="Nota" caption="Nota Contabila" :visible="false" :allowSearch="false"/>
    <DxColumn caption="Date Parteneri">
      <DxColumn data-field="GrupPartener" caption="Grup Partener" :visible="false" />
      <DxColumn data-field="Partener" caption="Nume Partener" :visible="false" />
      <DxColumn data-field="PartenerStrada" caption="Strada Partener" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="PartenerStradaNumar" caption="Numar Strada Partener" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="PartenerScaraBloc" caption="Scara Bloc Partener" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="PartenerBloc" caption="Bloc Partener" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="PartenerLocalitate" caption="Localitate Partener" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="PartenerAtributFiscal" caption="Atribut Fiscal Partener" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="PartenerCod" caption="Cod Partener" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="PartenerCUI" caption="CUI Partener" :visible="false" :allowSearch="false"/>
    </DxColumn>
    <DxColumn caption="Termene">
      <DxColumn data-field="DataDoc" caption="Data Document" :visible="false" data-type="date" format="yyyy-MM-dd" />
      <DxColumn data-field="Scadenta" caption="Data Scadenta" :visible="false" data-type="date" format="yyyy-MM-dd" />
    </DxColumn>
    <DxColumn caption="CAF">
      <DxColumn data-field="AreCAF" caption="Are CAF?" :visible="false" cell-template="circleTemplate" :allowSearch="false"/>
      <DxColumn data-field="ProcentCAF" caption="Procent CAF" :visible="false" data-type="number" format="#0.00" :allowSearch="false"/>
      <DxColumn data-field="ValoareCAF" caption="Valoare CAF" :visible="false" data-type="number" :allowSearch="false"/>
    </DxColumn>
    <DxColumn caption="Gestionare">
      <DxColumn data-field="GestiuneIntrare" caption="Gestiune Intrare" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="GestiuneIesire" caption="Gestiune Iesire" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="GestionarIntrare" caption="Gestionar Intrare" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="GestionarIesire" caption="Gestionar Iesire" :visible="false" :allowSearch="false"/>
    </DxColumn>
    <!-- <DxColumn data-field="Structura" caption="Structura" :visible="false" :allowFiltering="false" /> -->
    <DxColumn caption="Audit">
      <DxColumn data-field="DataCreare" caption="Data Creare" :visible="false" data-type="date" format="yyyy-MM-dd" />
      <DxColumn data-field="DataModificare" caption="Data Modificare" :visible="false" data-type="date"
        format="yyyy-MM-dd" />
      <DxColumn data-field="UserCreare" caption="User Creare" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="UserModificare" caption="User Modificare" :visible="false" :allowSearch="false"/>
    </DxColumn>
    <DxColumn caption="Rezumat Financiar RON">
      <DxColumn data-field="ValoareRON" caption="Valoare in RON" :visible="false" data-type="number" alignment="right"
        format="#0.00" :allowSearch="false"/>
      <DxColumn data-field="ValoareTVARON" caption="Valoare TVA in RON" :visible="false" data-type="number"
        format="#0.00" :allowSearch="false"/>
      <DxColumn data-field="TotalRON" caption="Total in RON" :visible="false" data-type="number" format="#0.00" :allowSearch="false"/>
      <DxColumn data-field="SoldRON" caption="Sold RON" :visible="false" data-type="number" :allowSearch="false"/>
    </DxColumn>
    <DxColumn caption="Rezumat Financiar">
      <DxColumn data-field="Valoare" caption="Valoare" :visible="false" data-type="number" alignment="right"
        format="#0.00" :allowSearch="false"/>
      <DxColumn data-field="Valuta" :visible="false" :allowSearch="false"/>
      <DxColumn data-field="TVA" caption="TVA" :visible="false" data-type="number" alignment="right" format="#0'%'" :allowSearch="false"/>
      <DxColumn data-field="ValoareTVA" caption="Valoare TVA" :visible="false" data-type="number" format="#0.00" :allowSearch="false"/>
      <DxColumn data-field="Total" caption="Total" :visible="false" data-type="number" format="#0.00" :allowSearch="false"/>
      <DxColumn data-field="Adaos" caption="Adaos" :visible="false" data-type="number" format="#0.00" :allowSearch="false"/>
      <DxColumn data-field="AdaosValoare" caption="Valoare Adaos" :visible="false" data-type="number" format="#0.00" :allowSearch="false"/>
      <DxColumn data-field="Sold" caption="Sold" :visible="false" data-type="number" :allowSearch="false"/>
    </DxColumn>
    <!-- <DxColumn cell-template="shareTemplate" :width="30" alignment="center" />

    <template #shareTemplate="{ data }">
      <DxButton icon="share" hint="Share" type="success" styling-mode="contained" @click="shareClicked(data.data)" />
    </template> -->

    <template #circleTemplate="{ data }">
      <div class="circle-container">
        <div v-if="data.value" class="circle circle-true">✔</div>
        <div v-else class="circle circle-false"></div>
      </div>
    </template>

    <template #numarLinkTemplate="{ data }">
      <a class="numar-link" @click.prevent="openDocument(data.data)">
        {{ data.value }}
      </a>
    </template>

    <template #filterToggleTemplate>
      <DxButton icon="filter" text="Filtre" styling-mode="contained" class="filter-toggle-btn"
        @click="$emit('toggle-filters')" />
    </template>

    <template #periodToggleTemplate>
      <DxButton icon="event" text="Perioadă" styling-mode="contained" class="filter-toggle-btn"
        @click="$emit('toggle-filters', 'date')" />
    </template>

    <template #documentToggleTemplate>
      <DxButton icon="doc" text="Document" styling-mode="contained" class="filter-toggle-btn"
        @click="$emit('toggle-filters', 'document')" />
    </template>
  </DxDataGrid>

  <DxPopup :visible="sharePopupVisible" width="430" height="170" :showTitle="true" :hideOnOutsideClick="switchSharePopup"
    :drag-enabled="true" position="center">
    <template #title>
      <div
        style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
        Copiază Link Detalii Document
      </div>
    </template>
    <div class="url-textbox">
      <DxTextBox :value="url" :readOnly="false">
        <DxTextBoxButton :options="copyButton" name="copy" :readOnly="false" />
      </DxTextBox>
    </div>
  </DxPopup>
  <DxPopupAdd :visible="isModalAddVisible" :show-title="true" height="870px">
    <template #title>
      <div class="popup-header">
        <div class="popup-header-main">
          <span class="popup-header-icon dx-icon-add"></span>
          <div class="popup-header-texts">
            <div class="popup-header-title">Adăugare document</div>
            <div class="popup-header-subtitle">
              Completează detaliile documentului în pașii de mai jos
            </div>
          </div>
        </div>
        <div class="popup-header-meta">
          <span class="status-chip status-chip--draft">
            Nou
          </span>
        </div>
      </div>
    </template>
    <DxForm :col-count="3" :data-source="newDocument" class="modern-form">
      <!-- Group 1: Informații Generale -->
      <DxGroupItem caption="Informații Generale" :col-span="2" :col-count="3"
        css-class="form-section-simple form-section-card">
        <DxSimpleItem :col-span="1" data-field="TipId" :is-required="true" :label="{ text: 'Tip Document' }">
          <template #default>
            <DxDropDownBox ref="dropDownBoxRef" :data-source="dsTipDocumente" :value="newDocument.TipId" value-expr="Id"
              display-expr="Nume" placeholder="Selectează un tip de document..." :showClearButton="true"
              @value-changed="onDropDownValueChanged">
              <template #content="{ data }">
                <DxTreeView v-if="treeViewDataSource" :data-source="treeViewDataSource" :select-by-click="true"
                  data-structure="tree" items-expr="items" key-expr="Id" :search-enabled="true" search-mode="contains"
                  :select-nodes-recursive="false" :expand-nodes-on-search="true"
                  @item-click="onTreeViewItemSelectionChanged" :focus-state-enabled="true" display-expr="Nume">
                  <template #item="{ data: itemData }">
                    <span :style="{ fontWeight: itemData.isCategory ? 'bold' : 'normal' }"> {{ itemData.Nume }} </span>
                  </template>
                </DxTreeView>
              </template>
            </DxDropDownBox>
          </template>
        </DxSimpleItem>

        <DxSimpleItem :col-span="1" data-field="Numar" :label="{ text: 'Număr Document' }" placeholder="#AUTO" />

        <DxSimpleItem :col-span="1" data-field="ContractId" :label="{ text: 'Contract' }">
          <template #default>
            <DxLookup :data-source="dsContracte" :value="newDocument.ContractId" value-expr="Id"
              display-expr="NumeContract" placeholder="Selectează un contract..." :showClearButton="true"
              :searchEnabled="true" :element-attr="{ class: !newDocument.ContractId ? '' : '' }"
              @value-changed="onContractSelected">
              <DxDropDownOptions :show-title="false" />
            </DxLookup>
          </template>
        </DxSimpleItem>
        <DxSimpleItem :col-span="2" data-field="PartenerId" :label="{ text: 'Partener' }">
          <template #default>
            <DxLookup :data-source="dsPartener" :value="newDocument.PartenerId" value-expr="ID" display-expr="Nume"
              placeholder="Selectează un partener..." :showClearButton="true" :searchEnabled="true"
              :element-attr="{ class: !newDocument.PartenerId ? '' : '' }" @value-changed="onPartenerSelected">
              <DxDropDownOptions :show-title="false" />
            </DxLookup>
          </template>
        </DxSimpleItem>

        <DxSimpleItem :col-span="1" data-field="ComandaId" :label="{ text: 'Comandă' }">
          <template #default>
            <DxLookup :data-source="dsComenzi" :value="newDocument.ComandaId" value-expr="Id" display-expr="cod"
              placeholder="Selectează o comandă..." :showClearButton="true" :searchEnabled="true"
              :element-attr="{ class: !newDocument.ComandaId ? '' : '' }" @value-changed="onComandaSelected">
              <DxDropDownOptions :show-title="false" />
            </DxLookup>
          </template>
        </DxSimpleItem>



        <DxSimpleItem :col-span="2" data-field="ProiectId" :label="{ text: 'Proiect' }">
          <template #default>
            <DxLookup :data-source="dsProiecte" :value="newDocument.ProiectId" value-expr="Id" display-expr="Nume"
              placeholder="Selectează un proiect..." :showClearButton="true" :searchEnabled="true"
              :element-attr="{ class: !newDocument.ProiectId ? '' : '' }" @value-changed="onProiectSelected">
              <DxDropDownOptions :show-title="false" />
            </DxLookup>
          </template>
        </DxSimpleItem>



        <DxSimpleItem :col-span="1" data-field="StructIdEditabil" :label="{ text: 'Structură Editabilă' }">
          <template #default>
            <DxLookup :data-source="dsStructuriIdEditabile" :value="newDocument.StructIdEditabil" value-expr="Id"
              display-expr="Nume" placeholder="Selectează o structură..." :showClearButton="true" :searchEnabled="true"
              @value-changed="onStructuraIdEditabilaSelected">
              <DxDropDownOptions :show-title="false" />
            </DxLookup>
          </template>
        </DxSimpleItem>
      </DxGroupItem>

      <!-- Group 2: Termene & Date -->
      <DxGroupItem caption="Termene & Date" :col-span="1" :col-count="1"
        css-class="form-section-simple form-section-card">
        <DxSimpleItem data-field="Data" :label="{ text: 'Data Contabilă' }">
          <template #default>
            <DxDateBox v-model:value="newDocument.Data" type="date" display-format="dd-MM-yyyy"
              :show-clear-button="true" placeholder="Data..." label-mode="hidden" />
          </template>
        </DxSimpleItem>
        <DxSimpleItem data-field="DataDoc" :label="{ text: 'Data Document' }">
          <template #default>
            <DxDateBox v-model:value="newDocument.DataDoc" type="date" display-format="dd-MM-yyyy"
              :show-clear-button="true" placeholder="Data document..." label-mode="hidden" />
          </template>
        </DxSimpleItem>
        <DxSimpleItem data-field="DataScadenta" :label="{ text: 'Data Scadență' }">
          <template #default>
            <DxDateBox v-model:value="newDocument.DataScadenta" type="date" display-format="dd-MM-yyyy"
              :show-clear-button="true" placeholder="Selectează data scadenței..." label-mode="hidden" />
          </template>
        </DxSimpleItem>
        <!-- <DxSimpleItem data-field="Rezervat" :label="{ text: 'Rezervat Până La' }">
          <template #default>
            <DxDateBox v-model:value="newDocument.Rezervat" type="date" display-format="dd-MM-yyyy"
              :show-clear-button="true" placeholder="Selectează data rezervării..." label-mode="hidden" />
          </template>
        </DxSimpleItem> -->
      </DxGroupItem>

      <!-- Group 3: Financiar & Logistică -->
      <DxGroupItem caption="Financiar & Logistică" :col-span="2" :col-count="2"
        css-class="form-section-simple form-section-card">
        <DxGroupItem :col-count="1">
          <DxSimpleItem data-field="GestiuneIntrareId" :label="{ text: 'Gestiune Intrare' }">
            <template #default>
              <DxLookup :data-source="dsGestiune" :value="newDocument.GestiuneIntrareId" value-expr="Id"
                display-expr="Nume" placeholder="Selectează gestiunea de intrare..." :showClearButton="true"
                :searchEnabled="true" @value-changed="onGestiuneIntrareSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </template>
          </DxSimpleItem>
          <DxSimpleItem data-field="GestiuneIesireId" :label="{ text: 'Gestiune Ieșire' }">
            <template #default>
              <DxLookup :data-source="dsGestiune" :value="newDocument.GestiuneIesireId" value-expr="Id"
                display-expr="Nume" placeholder="Selectează gestiunea de ieșire..." :showClearButton="true"
                :searchEnabled="true" @value-changed="onGestiuneIesireSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </template>
          </DxSimpleItem>
        </DxGroupItem>

        <DxGroupItem :col-count="2">
          <DxSimpleItem data-field="ValutaId" :label="{ text: 'Valută' }">
            <template #default>
              <DxLookup :data-source="dsValute" :value="newDocument.ValutaId" value-expr="Id" display-expr="Simbol"
                placeholder="Selectează valuta..." :showClearButton="true" :searchEnabled="true"
                @value-changed="onValutaSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </template>
          </DxSimpleItem>
          <DxSimpleItem data-field="Curs" :label="{ text: 'Curs' }">
            <template #default>
              <DxNumberBox :value="newDocument.Curs" :readOnly="true" @value-changed="onCursSelected" />
            </template>
          </DxSimpleItem>
          <DxSimpleItem data-field="PretValutaId" :label="{ text: 'Preț Valută' }">
            <template #default>
              <DxLookup :data-source="dsValute" :value="newDocument.PretValutaId" value-expr="Id" display-expr="Simbol"
                placeholder="Selectează valuta preț..." :showClearButton="true" :searchEnabled="true"
                @value-changed="onPretValutaSelected">
                <DxDropDownOptions :show-title="false" />
              </DxLookup>
            </template>
          </DxSimpleItem>
          <DxSimpleItem data-field="PretCurs" :label="{ text: 'Preț Curs' }">
            <template #default>
              <DxNumberBox :value="newDocument.PretCurs" :readOnly="true" @value-changed="onPretCursSelected" />
            </template>
          </DxSimpleItem>

        </DxGroupItem>

      </DxGroupItem>

      <!-- Group 4: Note & Observații -->
      <DxGroupItem caption="Note & Observații" :col-span="1" :col-count="1"
        css-class="form-section-simple form-section-card">
        <DxSimpleItem data-field="Explicatie" :label="{ text: 'Explicație' }">
          <template #default>
            <DxTextArea :value="newDocument.Explicatie" height="70px" @value-changed="onExplicatieSelected" />
          </template>
        </DxSimpleItem>
        <DxSimpleItem data-field="Observatii" :label="{ text: 'Observații' }">
          <template #default>
            <DxTextArea :value="newDocument.Observatii" height="70px" @value-changed="onObservatiiSelected" />
          </template>
        </DxSimpleItem>
      </DxGroupItem>
    </DxForm>
    <div class="form-footer footer-modern">
      <div class="footer-right">
        <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined" @click="onSaveAdd" />
        <DxButton text="Închide" type="danger" width="120" height="32" styling-mode="outlined" @click="onCloseAdd" />
      </div>
    </div>
  </DxPopupAdd>

</template>
<script lang='ts'>
import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxEditing,
  DxExport,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxHeaderFilter,
  DxLoadPanel,
  DxPager,
  DxPaging,
  DxRemoteOperations,
  DxScrolling,
  DxSearchPanel,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxTexts,
  DxToolbar,
  DxToolbarItem,
  DxItem
} from 'devextreme-vue/data-grid';
import DxTreeView from 'devextreme-vue/tree-view';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import { DxNumberBox } from "devextreme-vue/number-box"
import DxDateBox from 'devextreme-vue/date-box';
import { DxLookup, DxDropDownOptions } from 'devextreme-vue/lookup';
import DxContextMenu from 'devextreme-vue/context-menu'
import { DxForm, DxSimpleItem, DxGroupItem, DxRequiredRule, DxEmptyItem } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import { DxButton } from 'devextreme-vue/button';
import DxTextArea from 'devextreme-vue/text-area'
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';
import 'devextreme/data/array_store';
import DataSource from "devextreme/data/data_source";
import ArrayStore from "devextreme/data/array_store";
import { DxPopup } from 'devextreme-vue';
import DxActionSheet from 'devextreme-vue/action-sheet';
import notify from 'devextreme/ui/notify'
import DOC_Documente from '@/services/Documente/DOC_Documente';

export default {

  name: 'DocumentView',
  components: {
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxColumnChooser,
    DxLookup,
    DxEditing,
    DxScrolling,
    DxLoadPanel,
    DxRemoteOperations,
    DxHeaderFilter,
    DxPaging,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxPopup,
    DxContextMenu,
    DxActionSheet,
    DxButton,
    DxTextBox,
    DxTextBoxButton,
    DxToolbar,
    DxToolbarItem,
    DxItem,
    DxPopupAdd,
    DxForm,
    DxSimpleItem,
    DxDropDownOptions,
    DxTextArea,
    DxDateBox,
    DxNumberBox,
    DxGroupItem,
    DxRequiredRule,
    DxDropDownBox,
    DxTreeView
  },
  props: {
    initialFilters: {
      type: Object,
      default: null
    }
  },
  watch: {
    initialFilters: {
      handler(newVal) {
        this.loadData(newVal)
      },
      immediate: true
    }
  },
  data() {
    return {
      dsDocumente: null,
      dsTipDocumente: null,
      dsPartener: null,
      dsGestiune: null,
      dsValute: null,
      dsBanci: null,
      dsComenzi: null,
      dsProiecte: null,
      dsContracte: null,
      dsStructuriIdEditabile: null,
      documenteDataGrid: 'documenteDataGrid',
      dsCategorieDocumente: null,
      dsCursValutar: null,
      document: Object,
      menuAppear: false,
      contextMenuItems: [
        { text: "Vezi Detalii", action: "details" },
        { text: "Option 2" },
        { text: "Option 3" }
      ],
      sharePopupVisible: false,
      sharedDocumentId: '',
      copyButton: {
        icon: 'copy',
        stylingMode: 'text',
        onClick: this.copyToClipboard
      },
      url: '',
      addButtonOptions: {
        icon: "add",
        type: "success",
        stylingMode: "contained",
        onClick: () => {
          this.onAddClick()
        },
      },
      isModalAddVisible: false,
      newDocument: {
        TipId: null,
        Numar: '#AUTO',
        Data: new Date(),
        PartenerId: null,
        GestiuneIntrareId: null,
        GestiuneIesireId: null,
        GestionarIntrareId: null,
        GestionarIesireId: null,
        ValutaId: null,
        LotFabricatieId: null,
        SpitalizareId: null,
        Curs: 1,
        Tva: 0,
        Explicatie: '',
        Observatii: '',
        ContBancaCasaId: null,
        ComandaId: null,
        StructuraId: null,
        ProiectId: null,
        DocGeneratAutomatId: null,
        ContractId: null,
        AgentId: null,
        Rezervat: null,
        DataDoc: new Date(),
        StructIdEditabil: null,
        DataScadenta: null,
        PretValutaId: null,
        PretCurs: null,
        PunctDeLucru: '',
        BatchId: null,
      },
      treeViewDataSource: null,
      selectedTipId: null,
      dropDownBoxRef: null,
      externalFilters: null as any
    }
  },
  mounted() {
    this.dsCategorieDocumente = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + 'DOC_Categorii',
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        },
      },
      pageSize: 500
    });
    this.dsTipDocumente = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `DOC_Tipuri`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        },
      },
      pageSize: 500,
    });
    this.loadAndTransformData()
    this.dsPartener = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `PAR_Parteneri`,
        key: 'ID',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsGestiune = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `GES_Gestiuni`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsValute = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_ComercialOdata + `ERP_Valute`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsContracte = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_ComercialOdata + `COM_Contracte`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsBanci = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `ERP_BanciConturi`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsComenzi = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `PRO_Comenzi`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsProiecte = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + `DOC_Proiecte`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsStructuriIdEditabile = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_DocumenteOdata + 'ERP_StructuraCompanie',
        key: 'Id',
        keyType: "Guid",
        version: 4,
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      }
    });
    this.dsCursValutar = new DataSource({
      store: {
        type: 'odata',
        url: AppSetting.API_Url_ComercialOdata + `ERP_CursValutar`,
        key: 'Id',
        keyType: "Guid",
        version: 4,
        fieldTypes: {
          ValutaID: "Guid"
        },
        beforeSend: (e: any) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
          };
        }
      },
    });
    this.dsDocumente = new DataSource({
          store: {
            type: "odata",
            url: AppSetting.API_Url_DocumenteOdata + "DOC_CautareDocumente",
            key: "Id",
            keyType: "Guid",
            version: 4,
            beforeSend: (e: any) => {
              e.headers = {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + (localStorage.getItem("ERA_Jwt") ?? "")
              };
            }
          },
          // important: dacă vrei server-side ops
          // paginate: true,
    });
  },
  // watch: {
  //   initialFilters: {
  //     handler(newVal) {
  //       this.loadData(newVal)
  //     },
  //     immediate: true
  //   }
  // },
  methods: {
    async copyToClipboard() {
      const textToCopy = this.url

      if (!textToCopy) {
        notify('Nu există ID de document de copiat.', 'warning', 5000);
        return;
      }

      try {
        await navigator.clipboard.writeText(textToCopy);
        notify('Adresa URL a fost copiată', 'success', 5000);
      } catch (err) {
        console.error('Eroare la copiere:', err);
        notify('Eroare la copiere. Copiere manuală necesară.', 'error', 5000);
      }
    },
    async loadAndTransformData() {
      try {
        const [categories, documentTypes] = await Promise.all([
          this.dsCategorieDocumente.load(),
          this.dsTipDocumente.load()
        ])

        const categoryMap = new Map()
        const hierarchicalData = []

        categories.forEach(cat => {
          const categoryNode = {
            Id: cat.Id,
            Nume: cat.Nume,
            isCategory: true,
            items: []
          }

          categoryMap.set(cat.Id.toString().toLowerCase().trim(), categoryNode)
          hierarchicalData.push(categoryNode)
        })

        documentTypes.forEach(tip => {
          if (!tip.CategorieId) {
            return
          }

          let parentCategory = categoryMap.get(String(tip.CategorieId).toLowerCase().trim())
          if (parentCategory) {
            parentCategory.items.push({
              Id: tip.Id,
              Nume: tip.Nume,
              isCategory: false,
              items: []
            })
          } else {
            console.error(`Tipul de document ${tip.Nume} nu are o parinte categorie cu id ul: ${tip.CategorieId}`)
          }
        })

        this.treeViewDataSource = new DataSource({
          store: new ArrayStore({
            key: "Id",
            data: hierarchicalData
          })
        })
      } catch (error) {
        console.error("Error loading or transforming data for TreeView:", error)
      }
    },
    onTreeViewItemSelectionChanged(e: any) {
      const selectedItem = e.itemData

      if (selectedItem && !selectedItem.isCategory) {
        this.newDocument.TipId = selectedItem.Id

        const dropDownBoxInstance = this.$refs.dropDownBoxRef;

        if (dropDownBoxInstance && dropDownBoxInstance.instance) {
          dropDownBoxInstance.instance.close();
        } else {
          console.error("Could not find DropDownBox instance to close.");
        }
      }
    },
    onDropDownValueChanged(e: any) {
      this.selectedTipId = e.value
      this.newDocument.TipId = e.value
    },
    onStructuraIdEditabilaSelected(e: any) {
      this.newDocument.StructIdEditabil = e.value
    },
    onContractSelected(e: any) {
      this.newDocument.ContractId = e.value
    },
    onProiectSelected(e: any) {
      this.newDocument.ProiectId = e.value
    },
    onComandaSelected(e: any) {
      this.newDocument.ComandaId = e.value
    },
    createDocumenteDataSource() {
      return new DataSource({
        store: {
          type: "odata",
          url: AppSetting.API_Url_DocumenteOdata + "DOC_CautareDocumente",
          key: "Id",
          keyType: "Guid",
          version: 4,
          beforeSend: (e: any) => {
            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + (localStorage.getItem("ERA_Jwt") ?? "")
            };
          }
        }
      });
    },

    ensureDocumenteDataSource() {
      if (!this.dsDocumente) {
        this.dsDocumente = this.createDocumenteDataSource();
      }
    },
    loadData(params: any) {
      console.log("loadData called", JSON.stringify(params));
      this.externalFilters = params;

      this.ensureDocumenteDataSource();

      const rawFilters = Array.isArray(this.externalFilters?.filters) && this.externalFilters.filters.length > 0 ? this.externalFilters.filters : null;

      const combinedFilter = rawFilters;

      this.dsDocumente.filter(combinedFilter);

      return this.dsDocumente.reload();
    },
    refreshData() {
      return this.loadData(this.externalFilters);
    },
    onBancaSelected(e: any) {
      this.newDocument.ContBancaCasaId = e.value
    },
    onNumarSelected(e: any) {
      this.newDocument.Numar = e.value
    },
    onTVASelected(e: any) {
      this.newDocument.Tva = e.value
    },
    onExplicatieSelected(e: any) {
      this.newDocument.Explicatie = e.value
    },
    onObservatiiSelected(e: any) {
      this.newDocument.Observatii = e.value
    },
    onCursSelected(e: any) {
      this.newDocument.Curs = e.value
    },
    onPretCursSelected(e: any) {
      this.newDocument.PretCurs = e.value
    },
    onValutaSelected(e: any) {
      this.newDocument.ValutaId = e.value
      if (e.value === null) {
        this.newDocument.Curs = 1
        return
      }

      const ds = this.dsCursValutar;
      ds.filter(['ValutaID', '=', e.value]);
      ds.sort([{ selector: 'Data', desc: true }]);
      ds.pageSize(1);

      ds.load().then((res) => {
        if (res && res.length > 0) {
          this.newDocument.Curs = res[0].Curs;
        } else {
          // Fallback la cursul implicit din tabela de valute dacă nu există istoric
          this.dsValute.store().byKey(e.value).then((valuta) => {
            if (valuta) {
              this.newDocument.Curs = valuta.Curs || 1;
            }
          });
        }
      });
    },
    onPretValutaSelected(e: any) {
      this.newDocument.PretValutaId = e.value
      if (e.value === null) {
        this.newDocument.PretCurs = null
        return
      }

      const ds = this.dsCursValutar;
      ds.filter(['ValutaID', '=', e.value]);
      ds.sort([{ selector: 'Data', desc: true }]);
      ds.pageSize(1);

      ds.load().then((res) => {
        if (res && res.length > 0) {
          this.newDocument.PretCurs = res[0].Curs;
        } else {
          // Fallback la cursul implicit din tabela de valute dacă nu există istoric
          this.dsValute.store().byKey(e.value).then((valuta) => {
            if (valuta) {
              this.newDocument.PretCurs = valuta.Curs || null;
            }
          });
        }
      });
    },
    onGestiuneIntrareSelected(e: any) {
      this.newDocument.GestiuneIntrareId = e.value
    },
    onGestiuneIesireSelected(e: any) {
      this.newDocument.GestiuneIesireId = e.value
    },
    onTipDocumentSelected(e: any) {
      this.newDocument.TipId = e.value
    },
    onPartenerSelected(e: any) {
      this.newDocument.PartenerId = e.value
    },
    onAddClick() {
      this.isModalAddVisible = true
    },
    onCloseAdd() {
      this.isModalAddVisible = false
      this.newDocument.TipId = null
      this.newDocument.Numar = '#AUTO'
      this.newDocument.Data = new Date()
      this.newDocument.PartenerId = null
      this.newDocument.GestiuneIntrareId = null
      this.newDocument.GestiuneIesireId = null
      this.newDocument.ValutaId = null
      this.newDocument.Curs = 1
      this.newDocument.Tva = 0
      this.newDocument.Explicatie = ''
      this.newDocument.Observatii = ''
      this.newDocument.ComandaId = null
      this.newDocument.ProiectId = null
      this.newDocument.ContractId = null
      this.newDocument.AgentId = null
      this.newDocument.Rezervat = null
      this.newDocument.DataDoc = new Date()
      this.newDocument.StructIdEditabil = null
      this.newDocument.DataScadenta = null
      this.newDocument.PretValutaId = null
      this.newDocument.PretCurs = null
    },

    async onSaveAdd() {
      if (this.newDocument.TipId === null) {
        notify('Nu puteti crea un document fara tip!', 'error', 5000);
        return;
      }
      try {
        const response = await DOC_Documente.save(this.newDocument)
        if (response.status === 201 || response.status === 200) {
          notify('Documentul a fost salvat cu succes!', 'success', 5000);
          this.onCloseAdd()
          this.refreshData()
          this.$emit("select-document", response.data)
        } else {
          notify('Ceva a mers prost!', 'danger', 5000);
        }
      } catch (error: any) {
        console.error("A aparut o eroare la salvarea documentului: ", error);
        const errorMsg = error?.response?.data?.error?.message || error?.message || 'Eroare necunoscută';
        notify('Eroare: ' + errorMsg, 'error', 5000);
      }
    },
    shareClicked(data) {
      this.sharePopupVisible = true
      this.sharedDocumentId = data.Id
      this.url = `${window.location.origin}` + `/documente?id=${this.sharedDocumentId}`
    },
    switchSharePopup() {
      this.sharePopupVisible = !this.sharePopupVisible
    },
    onRowDblClick(e: any) {
      if (e.data) {
        this.openDocument(e.data);
      }
    },
    openDocument(data: any) {
      this.$emit("select-document", data);
    },
    // loadData(param) {
    //   this.dsDocumente = new DataSource({
    //     store: {
    //       type: 'odata',
    //       url: AppSetting.API_Url_DocumenteOdata + 'DOC_CautareDocumente',
    //       key: 'Id',
    //       keyType: "Guid",
    //       version: 4,

    //       beforeSend: (e: any) => {
    //         e.headers = {
    //           "Content-Type": "application/json",
    //           "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    //         };
    //       },
    //     },
    //   });
    //   this.dsDocumente.filter(param.filters);
    // },
  },
};
</script>
<style scoped>
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
  color: #fff;
}

.popup-header-main {
  display: flex;
  align-items: center;
  gap: 10px;
}

.popup-header-icon {
  font-size: 20px;
}

.popup-header-texts {
  display: flex;
  flex-direction: column;
}

.popup-header-title {
  font-size: 15px;
  font-weight: 700;
}

.popup-header-subtitle {
  font-size: 12px;
  opacity: 0.85;
}

.popup-header-meta {
  display: flex;
  align-items: center;
}


.status-chip {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.7);
}

.status-chip--draft {
  background-color: rgba(255, 255, 255, 0.18);
}


:deep(.form-section-simple) {
  .dx-form-group-caption {
    background: #f8f9fa;
    color: #333;
    font-size: 14px;
    font-weight: 600;
    padding: 10px 15px;
    margin: 15px 0 10px 0;
    border-left: 3px solid #ff2c21;
    border-radius: 0;
  }

  .dx-form-group-content {
    background: white;
    padding: 15px 0;
    margin-bottom: 10px;
  }
}

.form-section-card {
  background-color: #fff;
  border-radius: 10px;
  padding: 14px 16px !important;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
  margin-bottom: 12px;
}

.form-section-card .dx-field-item-label-text {
  font-weight: 600;
}

.footer-fixed {
  position: sticky;
  bottom: 0;
  padding: 10px 16px;
  display: flex;
  /* Forțează conținutul spre dreapta */
  justify-content: flex-end;
  gap: 12px;
  z-index: 10;
  /* Recomandat pentru sticky footer */
}

/* Eliminăm space-between care trimitea elementele în colțuri opuse */
.footer-modern {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px 24px;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
}

.footer-right {
  display: flex;
  gap: 12px;
  /* Spațiu între cele două butoane */
}

.circle-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.circle-true {
  background-color: #4caf50;
  color: white;
}

.circle-false {
  border: 2px solid #aaa;
}

/* Modern Form Styles */
.modern-form {
  padding: 10px;
}

.modern-form .dx-form-group-caption {
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 1px solid #ebedef;
  padding-bottom: 8px;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modern-form .dx-field-item {
  padding-bottom: 12px !important;
}

.modern-form .dx-field-item-label-text {
  font-weight: 500;
  color: #5d6d7e;
}

.url-textbox {
  margin-top: 23px;
}

.dx-popup-content .dx-form .dx-form-group {
  margin-right: 10px;
}

.dx-popup-content .dx-form .dx-field-item {
  padding-bottom: 15px;
  padding-right: 15px;
}

.dx-popup-content .dx-form .dx-field-item-label {
  margin-bottom: 5px;
}

.button-container {
  position: absolute;
  bottom: 15px;
  left: 20%;
  transform: translateX(-50%);
  display: flex;
  gap: 15px;
}

.dx-popup-content .dx-button {
  height: 45px;
  width: 150px;
}


.dx-texteditor.dx-invalid .dx-invalid-message {
  display: none;
}

.numar-link {
  color: #2563eb;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
}

.numar-link:hover {
  text-decoration: underline;
  color: #1d4ed8;
}
</style>
<style>
.filter-toggle-btn {
  background-color: white !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  color: #475569 !important;
  height: 36px !important;
  margin-right: 12px;
  transition: all 0.2s ease !important;
}

.filter-toggle-btn:hover {
  color: #ff2c21 !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}
</style>
